
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop-cart",
      function () {
        return require("private-next-pages/shop-cart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop-cart"])
      });
    }
  